import { useEffect, useState } from "react";
import { Row, Col, Card } from "react-bootstrap";

import { ReactComponent as AddIcon } from "@/assets/images/desktop/agregar.svg";
import { useLoadUnitInventory } from "@/hooks/implementation/unitInventoryLoad";
import Fetching from "@/components/Fetching/Fetching";
import CustomProcessingModal from "@/components/desktop/modal/CustomProcessingModal";

import UnitLoadTableItem from "./UnitLoadTable/UnitLoadTableItem";
import UnitLoadButtons from "./UnitLoadButtons";

import classes from "./loadinventory.module.scss";

const UnitLoad = ({
	data,
	setData,
	setUnitaryLoadSelected,
	products,
	setProducts,
	productsGenerics,
	setProductsGenerics,
	units_measurement,
	isFetching,
	lockNextBtn,
}) => {
	const { mutate, isLoading } = useLoadUnitInventory();

	const [activeProduct, setActiveProduct] = useState(true);

	useEffect(() => {
		if (data.items.length === 0) {
			handleAddItem();
		}
		// eslint-disable-next-line
	}, [data]);

	const handleAddItem = () => {
		setData({
			...data,
			items: [
				...data.items,
				{
					text_product: "",
					tradename: "",
					product_id: "",
					container_quantity: "",
					container_content: "",
					unit_measurement: "",
					total_price: "",
					expiration_date: "",
					generic: "",
				},
			],
		});
	};

	return (
		<div className={classes.unit_load} style={{ padding: data.is_implementation_completed ? "1em" : "0em" }}>
			<CustomProcessingModal open={isLoading} message="Guardando inventario..." />
			{isFetching ? (
				<Fetching />
			) : (
				<>
					<Row className={classes.row_global_card}>
						<Col md={12} className={classes.col_base}>
							<Card className={"active"}>
								<Card.Header onClick={() => setActiveProduct(!activeProduct)} className={activeProduct && "active"}>
									Productos
									<div>
										<span>
											<strong> Cantidad:</strong> {0}
										</span>
									</div>
								</Card.Header>
								{activeProduct && (
									<>
										<Card.Body>
											<Row className={classes.body_table}>
												<Col md={12} sm={12}>
													<UnitLoadTableItem
														data={data}
														setData={setData}
														products={products}
														setProducts={setProducts}
														productsGenerics={productsGenerics}
														setProductsGenerics={setProductsGenerics}
														units_measurement={units_measurement}
													/>
												</Col>
											</Row>
										</Card.Body>
										<Card.Footer>
											<AddIcon className={classes.iconAdd} onClick={() => handleAddItem()} />
										</Card.Footer>
									</>
								)}
							</Card>
						</Col>

						<UnitLoadButtons lockNextBtn={lockNextBtn} data={data} setUnitaryLoadSelected={setUnitaryLoadSelected} mutate={mutate} />
					</Row>
				</>
			)}
		</div>
	);
};

export default UnitLoad;
